import React from 'react';
import { Box, Stack, Typography, Button, Link } from '@mui/material';
import useMobile from '@/hooks/useMobile';
import Iconify from '@/components/Iconify';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import NewBadge from '@/components/NewBadge';

export default function Fan2FanItem({ link, data }) {
  const { isMobile } = useMobile();
  const { secondaryMarketClick } = useAnalyticsEvents();

  return (
    <Link href={link || '#'} target="_blank" rel="noopener" underline="none">
      <Box
        sx={{
          'opacity': 1,
          'boxShadow': (theme) => theme.customShadows.card,
          'mt': isMobile ? 1 : 2,
          'mb': isMobile ? 1 : 2,
          'padding': '16px',
          'border': (theme) => `0.5px solid ${theme.palette.grey[200]}`,
          'borderRadius': '16px',
          '&:hover': {
            cursor: 'pointer',
            border: (theme) =>
              `0.5px solid ${theme.palette.primary.palette[200]}`,
            background: (theme) => theme.palette.primary.palette[50],
            boxShadow:
              '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 0px 24px -4px rgba(145, 158, 171, 0.1)',
          },
        }}
        onClick={() => {
          secondaryMarketClick(data);
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
          sx={{
            width: '100%',
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: '20px',
                height: '20px',

                color: (theme) =>
                  theme.palette.mode === 'light'
                    ? theme.palette.primary.main
                    : theme.palette.secondary.main,
              }}
            >
              <Iconify width={20} height={20} icon={'ph:storefront'} />
            </Box>
            <Stack>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography
                  variant="subtitle1"
                  component="div"
                  sx={{ color: (theme) => theme.palette.text.primary }}
                >
                  Boletos de fan a fan
                </Typography>
                <NewBadge />
              </Stack>
              <Typography
                variant="body2"
                component="div"
                color={(theme) => theme.palette.grey[500]}
              >
                Adquiere boletos de otros fans con la seguridad de Boletia.
              </Typography>
            </Stack>
          </Stack>
          <Box sx={{ widt: '20px' }}>
            <Button
              sx={{
                backgroundColor: (theme) => theme.palette.primary.palette[50],
                display: 'flex',
                alignItems: 'center',
                pb: 1,
                padding: 0,
                border: (theme) =>
                  `0.5px solid ${theme.palette.primary.palette[100]}`,
                borderRadius: '4px',
                minWidth: '8px',
              }}
            >
              <Iconify
                width={20}
                height={20}
                icon={'mdi:keyboard-arrow-right'}
              />
            </Button>
          </Box>
        </Stack>
      </Box>
    </Link>
  );
}
